import Http from "./http";

export const getFormations = async ({ studentId }) => {
  let data = await Http.get(`/students/${studentId}/formations`);
  return data.data;
};

export const getModuleGroup = async ({ studentId, moduleGroup }) => {
    let data = await Http.get(`/students/${studentId}/moduleGroup/${moduleGroup}`);
    return data.data;
};